module.exports = __webpack_public_path__ + "static/media/comunicacao-login-rv.7caa7a4c.png";